export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';

export interface EntityCommonProps {
    // Single table design keys
    PK: string,
    SK: string,

    // Traceability attributes
    createdAt: number,
    updatedAt: number,
}

export type SignUpUserDto = {
    email?: string;
    name?: string;
    role?: string
    subscriptionId: string;
    password?: string;
    uniLoginUsername?: string;
    subscribeNewsLetter?: boolean|string;
}

export type UpdateUserDto = {
    email: string;
    name: string;
    password: string;
}

export interface UserDto extends SignUpUserDto, EntityCommonProps {}

export interface UserTokensDto {
    AccessToken: string;
    ExpiresIn: number;
    TokenType: string;
    RefreshToken: string;
    IdToken: string;
}

export const grades = ['0-10 kl.', '0-6 kl.', '4-10 kl.', 'indskoling', 'mellemtrin', 'udskoling', '0. klasse',
    '1. klasse', '2. klasse', '3. klasse', '4. klasse', '5. klasse', '6. klasse', '7. klasse', '8. klasse',
    '9. klasse', '10. klasse']

export type Grades = (typeof grades[number])
export const subjects = ['Matematik', 'Fysik', 'Kemi', 'Biologi', 'Dansk', 'Spil & Gaming', 'Engelsk'
    , 'Film', 'Musik', 'Sport', 'YouTube', 'Idræt & Bevægelse', 'Geografi', 'Billedkunst', 'Historie',
    'Videnskab', 'Tysk', 'Social/Hygge', 'Samfundsfag', 'Berømte & Berygtede', 'Mode & Mærker', 'Bøger']
export type Subjects = typeof subjects[number]


export interface CreateCategoryDto {
    name: string,
    subject: Subjects,
    grade: Grades,
}

export interface Table {
    columns: {
        [key: string]: any;
    }[];
    rows: {
        [key: string]: any;
    }[];
}

export interface CategoryDto extends CreateCategoryDto, EntityCommonProps {
    hasAudio?: boolean
    hasPictures?: boolean
}

export interface CreateSubCategoryDto {
    name: string,
    color: string,
    isShared?: boolean,
    fromAdmin?: boolean,
    grade: string
}

export interface SubCategoryDto extends CreateSubCategoryDto, EntityCommonProps {
    [x: string]: any;
}

export interface CreateQuizDto {
    title: string,
    description: string,
    answer: string,
    descriptionImage?: string,
    descriptionAudio?: string,
    answerImage?: string,
    answerAudio?: string,
    category: string,
}

export interface QuizDto extends Omit<CreateQuizDto, 'category'>, EntityCommonProps {
    category: { category: string; name: string; grade: string; subject: string },
    subcategory: { name: string; subcategory: string; grade: string; }
}

export enum CreatedBy {
    QuizEdu = 'QuizEdu',
    Mig = 'Mig',
    Andre = 'Andre'
}

export interface CreateCardCollectionDto {
    name: string,
    subCategories: SubCategoryDto['PK'][],
    categories: CategoryDto['PK'][],
    grades: Grades[],
    subjects: Subjects[]
    jokerCard: boolean,
    createdBy: CreatedBy
}

export interface CardCollectionDto extends Omit<CreateCardCollectionDto, 'subCategories'>, EntityCommonProps {
    subCategories: SubCategoryDto
}
const subcategoryPk: unique symbol = Symbol()

export interface SubCategoriesWithQuizzesDto {
    [subcategoryPk]: {
        name: SubCategoryDto['name'],
        color: SubCategoryDto['color'],
        isShared?: SubCategoryDto['isShared'],
        fromAdmin?: SubCategoryDto['fromAdmin'],
        PK: SubCategoryDto['PK']
        SK: SubCategoryDto['SK']
        createdAt: SubCategoryDto['createdAt']
        updatedAt: SubCategoryDto['updatedAt']
        quizzes: QuizDto[]
    }
}

export interface Answer {
    answerDateTime: Date
    answer: string
    correct: boolean
    subCategory: SubCategoryDto['PK'];
    quizId: QuizDto['PK'];
}

export interface CreateUpdateScoreDto {
    answers: Answer[];
    cardCollectionId: CardCollectionDto['PK'];
    score: number
    progress: number
}

export interface CreateUpdatePlaySessionDto { }

export interface PlaySessionDto extends EntityCommonProps {
    indexes: { [key: string]: number[] };
    userId: UserDto['PK']
}

export interface ScoreDto extends Omit<CreateUpdateScoreDto, 'cardCollectionId'>, EntityCommonProps {
    cardCollectionId: CardCollectionDto;
}


export interface CardCollectionWithSubcategories extends Omit<CardCollectionDto, 'subCategories'> {
    subCategories: {
        [x: string]: SubCategoryDto[];
    }[];
}

export type returnCardCollectionAndCategories = {
    cardCollections: CardCollectionWithSubcategories[]
    categories: CategoryDto[]
}

export interface SendInvitationProps {
    quizInfo: {
        grade: Grades,
        subject: Subjects,
        category: CategoryDto['PK'],
        subCategory: SubCategoryDto['PK'],
        title: QuizDto['title']
        question: {
            description?: QuizDto['description'],
            descriptionImage?: QuizDto['descriptionImage'],
            descriptionAudio?: QuizDto['descriptionAudio']
        },
        answer: {
            answer?: QuizDto['answer'],
            answerImage?: QuizDto['answerImage'],
            answerAudio?: QuizDto['answerAudio']
        },
    },
    comment: string
}

export type CouponValidityType = {
    isValid: boolean
    discountPercent?: number
}

export type ActiveSubscriptionType = {
    handle: string,
    joinedAt: string,
    expiresAt: string
}

export type CustomerActiveSubscriptions = {
    subscriptions: ActiveSubscriptionType[]
}

export type PricePlan = '1year' | '1year-school'